import { CheckoutOrder, CheckoutProduct, PaymentForm } from "tm-shared/types";

import {
    FORM_1_COMMENTS,
    FORM_2_COMMENTS,
} from "@/pages/Checkout/constants/comments";

interface PaymentFormEntry {
    orderId: string;
    isCarrier?: boolean;
    isSelfDelivery?: boolean;
    comments?: string[];
    isCredit: boolean;
    shipmentDate?: string;
}

interface FormData {
    isCarrier?: { checked: boolean };
    isSelfDelivery?: { checked: boolean };
    isPayOnDelivery?: { checked: boolean };
    commentDetails?: { checked: boolean; comment?: string };
}

export const convertCheckoutListToMarketProducts = (
    checkoutList: Record<string, CheckoutOrder>,
    ignoreRemainingsOrders: Record<string, unknown>,
) => {
    const marketProducts: Record<string, CheckoutProduct[]> = {};
    const ignoreRemainings: Record<string, { ignoreRemainings: boolean }> = {};
    const paymentForms: Record<string, string> = {};

    for (const orderId in checkoutList) {
        const { products, paymentForm } = checkoutList[orderId];

        marketProducts[orderId] = [];
        const productsMap: Record<string, CheckoutProduct> = {};

        for (const barcode in products) {
            const { name, price, count } = products[barcode];

            if (!productsMap[barcode]) {
                productsMap[barcode] = { barcode, name, price, count: 0 };
                marketProducts[orderId].push(productsMap[barcode]);
            }

            productsMap[barcode].count += count;
        }

        paymentForms[orderId] = paymentForm;

        if (orderId in ignoreRemainingsOrders) {
            ignoreRemainings[orderId] = { ignoreRemainings: true };
        }
    }

    return {
        marketProducts,
        ignoreRemainingsOrders: ignoreRemainings,
        paymentForms,
    };
};

export const processPaymentForm = (
    formData: FormData | undefined,
    orderId: string,
    formNumber: PaymentForm,
    customShipmentDate: string,
): PaymentFormEntry[] => {
    if (!formData) return [];

    const { isCarrier, isSelfDelivery, isPayOnDelivery, commentDetails } =
        formData;
    const isAnyFlagChecked =
        isCarrier?.checked ||
        isSelfDelivery?.checked ||
        isPayOnDelivery?.checked ||
        commentDetails?.checked;

    if (!isAnyFlagChecked) {
        if (customShipmentDate) {
            return [
                {
                    orderId,
                    isCredit: true,
                    shipmentDate: customShipmentDate,
                },
            ];
        } else {
            return [
                {
                    orderId,
                    isCredit: true,
                },
            ];
        }
    }

    const comments: string[] = [];

    if (commentDetails?.checked && commentDetails?.comment) {
        comments.push(commentDetails.comment);
    }

    if (formNumber === "1" && isPayOnDelivery?.checked) {
        comments.push(FORM_1_COMMENTS.isPayOnDelivery);
    }

    if (formNumber === "2") {
        if (isSelfDelivery?.checked)
            comments.push(FORM_2_COMMENTS.isSelfDelivery);

        if (isPayOnDelivery?.checked) {
            comments.push(
                isSelfDelivery?.checked
                    ? FORM_2_COMMENTS.isPayOnDeliveryisSelfDelivery
                    : FORM_2_COMMENTS.isPayOnDelivery,
            );
        }
    }

    return [
        {
            orderId,
            isCarrier: formNumber === "2" ? isCarrier?.checked : undefined,
            isSelfDelivery:
                formNumber === "2" ? isSelfDelivery?.checked : undefined,
            isCredit: !isPayOnDelivery?.checked,
            shipmentDate: customShipmentDate,
            comments,
        },
    ];
};
